import { css } from '@emotion/core';

export default css`
  width: 100%;
  height: auto;
  border: none !important;
  border-radius: 0 !important;
  @media screen and (max-width: 330px) {
    width: 100%;
  }
`;
